export default "__VITE_ASSET__CIPMhzj7__"